import { isLabStageId, type LabStageId } from "./navigation";

export const CANONICAL_STAGE_CHANGED_EVENT =
  "league-command:canonical-stage-changed";

export interface CanonicalStageChangedDetail {
  readonly stage: LabStageId;
  readonly stageVersion: number;
}

export const announceCanonicalStageChanged = (
  stage: string | null | undefined,
  stageVersion: number,
): void => {
  if (!isLabStageId(stage) || !Number.isInteger(stageVersion) || stageVersion < 0) {
    return;
  }
  window.dispatchEvent(
    new CustomEvent<CanonicalStageChangedDetail>(
      CANONICAL_STAGE_CHANGED_EVENT,
      { detail: { stage, stageVersion } },
    ),
  );
};

export const subscribeCanonicalStageChanged = (
  listener: (detail: CanonicalStageChangedDetail) => void,
): (() => void) => {
  const handle = (event: Event): void => {
    const detail = (event as CustomEvent<unknown>).detail;
    if (
      detail !== null &&
      typeof detail === "object" &&
      "stage" in detail &&
      typeof detail.stage === "string" &&
      isLabStageId(detail.stage) &&
      "stageVersion" in detail &&
      typeof detail.stageVersion === "number" &&
      Number.isInteger(detail.stageVersion) &&
      detail.stageVersion >= 0
    ) {
      listener({
        stage: detail.stage,
        stageVersion: detail.stageVersion,
      });
    }
  };
  window.addEventListener(CANONICAL_STAGE_CHANGED_EVENT, handle);
  return () => window.removeEventListener(CANONICAL_STAGE_CHANGED_EVENT, handle);
};
